export class Debug {
  // To debug the plugin, temporarily uncomment the body of this function
  public static log(message: string): void {
    // message = require("process").pid + ": " + message;
    // console.log(message);
    // require('fs').writeFileSync('C:\\Git\\log.txt', message + '\r\n', { flag: 'as' });
  }
}
